import { render, staticRenderFns } from "./PrivacyProtection.vue?vue&type=template&id=2b390df5&scoped=true&"
import script from "./PrivacyProtection.vue?vue&type=script&lang=js&"
export * from "./PrivacyProtection.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyProtection.vue?vue&type=style&index=0&id=2b390df5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b390df5",
  null
  
)

export default component.exports